module.exports = __webpack_public_path__ + "static/media/dhl.93da6742.svg";